import(/* webpackMode: "eager" */ "/var/www/next_factor/app/globals.css");
import(/* webpackMode: "eager" */ "/var/www/next_factor/app/providers.tsx");
import(/* webpackMode: "eager" */ "/var/www/next_factor/node_modules/nextjs-toploader/dist/index.js")